module.exports = __webpack_public_path__ + "static/img/kefu_icon.d376827a.png";